/**
 * 判断是否为对象
 *
 * @param {any} obj 传入对象
 * @return {boolean} 返回值
 */
function isObj(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
}

export { isObj as i };
//# sourceMappingURL=isObj-665859c3.js.map
